import { CssBaseline } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { deepmerge } from "@mui/utils";

import { getDesignTokens, getThemedComponents } from "./M3Theme";

const M3ThemeProvider = ({ children }) => {
  const designTokens = getDesignTokens();
  let m3Theme = createTheme({
    ...designTokens,
    typography: {
      fontFamily: "Figtree, sans-serif",
    },
  });
  m3Theme = deepmerge(m3Theme, getThemedComponents(m3Theme));

  return (
    <ThemeProvider theme={m3Theme}>
      <CssBaseline enableColorScheme />
      {children}
    </ThemeProvider>
  );
};

export default M3ThemeProvider;
